/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable react/no-unstable-nested-components */
import { IIndicatorCategory, IIndicatorDataSource, IIndicatorKind, IIndicatorVertical } from "types/graphqlTypes";
import { z } from "zod";

// See: https://transform.tools/typescript-to-zod
export const IndicatorFieldsSchema = z.object({
  objectId: z.string(),
  kind: z.nativeEnum(IIndicatorKind),
  category: z.nativeEnum(IIndicatorCategory),
  dataSource: z.nativeEnum(IIndicatorDataSource),
  vertical: z.array(z.nativeEnum(IIndicatorVertical)),
  viewerCanSee: z.boolean(),
  documentation: z.array(
    z.object({
      __typename: z.literal("IndicatorDocumentation"),
      languageCode: z.string(),
      name: z.string(),
      abbreviation: z.string().nullable(),
      description: z.string(),
    }),
  ),
  numberFormatOptions: z
    .object({
      __typename: z.literal("NumberFormatOptions"),
      style: z.string(),
      notation: z.string(),
      compactDisplay: z.string(),
      minimumFractionDigits: z.number(),
      maximumFractionDigits: z.number(),
      minimumSignificantDigits: z.number(),
      maximumSignificantDigits: z.number(),
      minimumIntegerDigits: z.number(),
    })
    .nullable(),
  columnTheme: z.object({
    __typename: z.literal("IndicatorColumnTheme"),
    backgroundColor: z.string(),
    textColor: z.string(),
  }),
});

export const INDICATORS_LIMIT = 40;
export const TemplateFormSchema = z.object({
  name: z
    .string()
    .min(2, "O nome deve ter no mínimo 2 caracteres")
    .max(36, "O nome deve ter no máximo 36 caracteres")
    .nonempty("O nome é obrigatório"),
  description: z
    .string()
    .min(2, "A descrição deve ter no mínimo 2 caracteres")
    .max(480, "A descrição deve ter no máximo 120 caracteres")
    .nonempty("A descrição é obrigatória"),
  isGlobalForVerticals: z.boolean(),
  indicators: z
    .array(IndicatorFieldsSchema)
    .min(1, "Selecione pelo menos um indicador")
    .max(INDICATORS_LIMIT, `Selecione no máximo ${INDICATORS_LIMIT} indicadores`),
});
export type TemplateFormData = z.infer<typeof TemplateFormSchema>;
